import { analyticsService } from '@coachmate/common'

export const useAnalytics = () => ({
  init: analyticsService.init,
  track: analyticsService.track,
})
